import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useWelcomeStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            maxWidth: '512px',
            width: '100%',
            margin: 'auto',
            marginTop: theme.spacing(2),
            paddingBottom: theme.spacing(4),
        },
        button: {
            marginTop: theme.spacing(6),
        },
        title: {
            marginBottom: theme.spacing(2),
        },
    }),
);

export default useWelcomeStyles;
